import styled from '@emotion/styled';
import { CloseForSearch, Search as SearchIcon } from '@shared/assets/index';
import type { SearchInputPT } from '@shared/ui/inputs/searchInput/ui';
import * as vars from '@shared/styles/abstracts/vars.module.scss';

export const SWrapper = styled.div`
		
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const SInput = styled.input<SearchInputPT>`

    height: 34px;
    min-width: 196px;
    border-radius: 17px;
    border: 1px solid ${props => props.error ? 'red' : vars.colorActive};
    background-color: inherit;
    padding-left: 39px;

    padding-right: 30px;

		
    &::placeholder {
        margin-left: 10px;
    }
		
    &:focus {
        outline: none;
        box-shadow: none;
    }
		&:disabled{
				opacity:0.7;
		}
		
`;

export const SIconWrapper = styled.div<{ error?: string }>`
    position: absolute;
    top: 4px;
`;

export const SLeftIconWrapper = styled(SIconWrapper)`
    left: 17px;

    svg {
        color: ${props => props.error ? 'red' : vars.colorActive};
    }

`;
export const SRightIconWrapper = styled(SIconWrapper)`
    cursor: pointer;
    right: 17px;
`;

export const SCloseForSearch = styled(CloseForSearch)`
    svg {
        width: 26px;
        height: 26px;
    }
`;

export const SSearchIcon = styled(SearchIcon)`
    svg {
        width: 12px;
        height: 16px;
    }
`;
export const SDopContent = styled.div`
    margin-left: 20px;
`;

export const SError = styled(SDopContent)`
		position:absolute;
    top: 40px;
    color: red;
`;